import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledCell } from './Tabs.styles.js';
import Button from '../Inputs/Button/Button.js';
import ButtonIcon from '../Inputs/Button/ButtonIcon/ButtonIcon.js';
import { BUTTON_TEXT_POSITION_MAP } from '../Inputs/Button/Button.constants.js';
import Typography from '../Typography/index.js';

var Tab = function Tab(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? '' : _ref$icon,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$displayText = _ref.displayText,
    displayText = _ref$displayText === void 0 ? BUTTON_TEXT_POSITION_MAP.HIDDEN : _ref$displayText,
    isActive = _ref.isActive,
    _ref$isParentTab = _ref.isParentTab,
    isParentTab = _ref$isParentTab === void 0 ? false : _ref$isParentTab,
    onTabChange = _ref.onTabChange,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var variant = isActive ? 'headingSmall' : 'bodyMedium';
  var hasIconAndLabel = icon && label;
  var Component = hasIconAndLabel ? ButtonIcon : Button;
  return React__default.createElement(StyledCell, {
    key: value,
    $active: isActive,
    $disabled: isDisabled,
    $isParentTab: isParentTab,
    role: "tab",
    "data-testid": testId
  }, React__default.createElement(Component, {
    ariaLabel: hasIconAndLabel ? 'tab-icon' : undefined,
    disabled: isDisabled,
    displayText: hasIconAndLabel ? displayText : undefined,
    icon: hasIconAndLabel ? icon : undefined,
    isDisabled: isDisabled,
    onClick: function onClick(e) {
      return onTabChange(e, {
        label: label,
        value: value
      });
    },
    size: "small",
    variant: "ghost"
  }, React__default.createElement(Typography, {
    variant: variant
  }, label)));
};
Tab.propTypes = {
  displayText: PropTypes.string,
  icon: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  isParentTab: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  testId: PropTypes.string,
  value: PropTypes.string.isRequired
};

export { Tab, Tab as default };
//# sourceMappingURL=Tab.js.map
